export class AgOverlayTemplate {
  static overlayProcessingTemplate: string = '<span class="ag-overlay-loading-center">Loading..</span>';
}



// WEBPACK FOOTER //
// ./src/app/components/ag-grid/ag-overlay-template.ts